import { render, staticRenderFns } from "./RollLog.vue?vue&type=template&id=ec8eb286&scoped=true&"
import script from "./RollLog.vue?vue&type=script&lang=js&"
export * from "./RollLog.vue?vue&type=script&lang=js&"
import style0 from "./RollLog.vue?vue&type=style&index=0&id=ec8eb286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8eb286",
  null
  
)

export default component.exports